import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'tpc-events-travel',
    templateUrl: './events-travel.component.html',
    styleUrls: ['./events-travel.component.css']
})
export class EventsTravelComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-travel.component.ts